import type { ShapeData } from '@/lib/shapes/types/shape-data'

export const GROUP_KIND_ID = 7

export function isGroupShape(shape: ShapeData): boolean {
  return shape.kindId === GROUP_KIND_ID
}
